import DictionaryItem from "../dictionary/DictionaryItem";


/**
 * Acquisition channel model.
 */
export default class AcquisitionChannel extends DictionaryItem {
	constructor(public readonly id: string,
		public readonly name: string,) {
		super(id, name);
	}
}